import React from 'react';
import { Button, Input, Tooltip } from 'antd';
import { BoldOutlined, InfoCircleOutlined, ItalicOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import TextArea from 'antd/es/input/TextArea';

const TemplateTextArea = ({
  title,
  description,
  placeholder,
  value,
  onChange,
  infoMessage,
  subDesc,
  isRequired,
  isVariables,
  addBodyVariable,
  minHeight,
  textAreaRef,
  setCursorPos,
  status,
  addBold,
  addItalic
}) => {

  const { t, i18n } = useTranslation();

  let heightStyle = {};
  if (minHeight) {
    heightStyle ={
      minHeight:minHeight
    }
  }

  const addEmojiClick =()=>{

  }
  
  return (
    <div>
      {/* Header with Info Icon */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '8px'
      }}>
        <div style={{
          display: 'flex',
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#333',
            fontFamily: 'Helvetica, sans-serif',
            marginRight: '10px',
          }}>
            {title}
          </h3>

          {/* Required/Optional Badge */}
          {isRequired ? (
            <div style={{
              padding: '2px 6px',
              backgroundColor: '#E6F7FF',
              borderRadius: '6px',
              fontSize: '14px',
              color: '#1890ff',
              fontWeight: '500',
              marginRight: '10px',
              height: '25px',
              display: 'flex',
              alignItems: 'center'
            }}>
              {t('required')}
            </div>
          ) : (
            <div style={{
              padding: '2px 6px',
              backgroundColor: '#FFF6E6',
              borderRadius: '6px',
              fontSize: '14px',
              color: '#000010',
              fontWeight: '500',
              marginRight: '10px',
              height: '25px',
              display: 'flex',
              alignItems: 'center'
            }}>
              {t('optional')}
            </div>
          )}
        </div>
        {
          infoMessage && infoMessage.length > 0 && (
            <Tooltip title={infoMessage}>
              <InfoCircleOutlined style={{ color: '#1890ff', fontSize: '18px' }} />
            </Tooltip>
          )
        }

      </div>

      {/* Açıklama */}
      <p style={{
        fontSize: '14px',
        color: '#595959',
        marginBottom: '16px',
        fontFamily: 'Verdana, sans-serif'
      }}>
        {description}
      </p>

     {/* <EmojiPicker /> */}
    {/* <Button onClick={addEmojiClick}>
                            🙂
                        </Button> */}
      {/* Input alanı */}
      <div style={{maxHeight:"400px"}}>
        <TextArea
          name="elementName"
          placeholder={placeholder}
          style={{height:"270px",resize:"none"}}
          // style={{
          //   width: '100%',
          //   padding: '12px',
          //   borderRadius: '8px',
          //   border: '1px solid #d9d9d9',
          //   boxSizing: 'border-box',
          //   fontFamily: 'Arial, sans-serif',
          //   fontSize: '14px',
          //   color: '#333',
          //   transition: 'border-color 0.3s ease',
          // }}
          value={value}
          onChange={onChange}
          maxLength={1024}
          showCount
          ref={textAreaRef}
          onSelect={(e)=>{
            setCursorPos(e.target.selectionStart)
          }}
          status={status}
        />
      </div>

      {/* Info Bilgisi */}
      <div style={{ color: '#595959', fontSize: '12px', fontFamily: 'Verdana, sans-serif' }}>
        {subDesc}
      </div>

      {
        isVariables &&
        (
          <div className="controls mt-2">
            <Button
              className="controls-right"
              type="button"
              onClick={addBodyVariable}
              style={{marginRight:"8px"}}
            >
              {t('addVariable')}
            </Button>

            <Button
              className="controls-right"
              type="button"
              onClick={addBold}
              style={{marginRight:"8px",width:"40px"}}
              icon={<BoldOutlined/>}
            >
            
            </Button>

            <Button
              className="controls-right"
              type="button"
              onClick={addItalic}
              style={{marginTop:"10px",width:"40px"}}
              icon={<ItalicOutlined/>}
            >
            
            </Button>
          </div>
        )
      }
    </div>

  );
};

export default TemplateTextArea;
